import { ANALYTICS_SUITE_IDS } from './templates';
export const SUITE_SCREEN_NAMES = {
  [ANALYTICS_SUITE_IDS.COMMERCE]: 'commerce-analytics',
  [ANALYTICS_SUITE_IDS.SERVICE]: 'service-analytics',
  [ANALYTICS_SUITE_IDS.SALES]: 'sales-analytics',
  [ANALYTICS_SUITE_IDS.MARKETING]: 'marketing-analytics'
};